import { createSlice } from '@reduxjs/toolkit'

import { fetchBillingInfo } from './actions/fetch_billing_info'

const billingInfoSlice = createSlice({
  name: 'billingInfo',
  initialState: {
    upgradeInfoLoading: true,
    upgradeInfo: {}
  },
  reducers: {
    resetUpgradeInfo: (state) => {
      state.upgradeInfoLoading = true
      state.upgradeInfo = {}
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchBillingInfo.pending, (state) => {
      state.upgradeInfoLoading = true
      state.upgradeInfo = {}
    })
    builder.addCase(fetchBillingInfo.fulfilled, (state, action) => {
      state.upgradeInfoLoading = false
      state.upgradeInfo = action.payload
    })
    builder.addCase(fetchBillingInfo.rejected, (state) => {
      state.upgradeInfoLoading = false
    })
  }
})

export const {
  reducer,
  actions: {
    resetUpgradeInfo
  }
} = billingInfoSlice
